import { PulseTourConfig, PulseTourStep } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';

const TOUR_KEY = 'multi-level-library-folder-tour';
const TOUR_STEPS: PulseTourStep[] =  [
	{
		completeSelectors: ['.add-folder-btn'],
		pulse: {
			selectors: ['.add-folder-btn']
		},
		popover: {
			title: 'library-collections_add-folder-tour-title',
			body: 'library-collections_add-folder-tour-body',
			position: 'above'
		}
	},
	{
		completeSelectors: ['.folder-tree-field > .mat-mdc-text-field-wrapper'],
		pulse: {
			selectors: ['.folder-tree-field > .mat-mdc-text-field-wrapper']
		},
		popover: {
			title: 'library-collections_add-folder-tour-title',
			body: 'add-collection-folder_destination-folder-tour-body',
			position: 'above'
		}
	}
];

export const MULTI_LEVEL_LIBRARY_FOLDER_TOUR_CONFIG: PulseTourConfig = {
	viewTrackKey: TOUR_KEY,
	steps: TOUR_STEPS,
	constraints: {
		tourStartDate: new Date('2025-11-10'),
		isOnboarding: false
	}
};
